// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "CustomSMTPResults": [
      "CustomSMTP",
      "CustomSMTPError"
    ],
    "EnrolmentOriginSection": [
      "PathwayModelAsStudent",
      "WorkspaceModelAsMember",
      "CertificationModelAsStudent"
    ],
    "ISearchable": [
      "EventModelAsAdmin",
      "PathwayModelAsAdmin",
      "TopicModelAsEditor",
      "WorkspaceModelAsMember"
    ],
    "IThemeModel": [
      "ThemeModelAsEditor",
      "ThemeModelAsMember"
    ],
    "ITopicModel": [
      "TopicModelAsEditor",
      "TopicModelAsMember"
    ],
    "IWorkspaceBookmarkModel": [
      "WorkspaceBookmarkModelAsCoordinator",
      "WorkspaceBookmarkModelAsMember"
    ],
    "IWorkspaceModel": [
      "WorkspaceModelAsCollaborator",
      "WorkspaceModelAsCoordinator",
      "WorkspaceModelAsMember"
    ],
    "QuickSearchResult": [
      "TopicModelAsMember",
      "WorkspaceModelAsMember",
      "PathwayModelAsStudent",
      "EventModelAsStudent",
      "SurveyModelAsStudent",
      "CampaignModel",
      "CertificationModelAsStudent",
      "GroupModelGQLBase"
    ],
    "SearchResult": [
      "TopicModelAsMember",
      "WorkspaceModelAsMember",
      "PathwayModelAsStudent",
      "EventModelAsStudent",
      "SurveyModelAsStudent",
      "CampaignModel",
      "CertificationModelAsStudent"
    ],
    "UserActivityHistoryItem": [
      "TopicEnrolmentModelAsStudent",
      "UserEventModel",
      "CPDManualEntryModel"
    ]
  }
};
      export default result;
    